import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    position: fixed;
    top: 0; 
    right: 0;
    height: 100%;
    width: 100%;

    
    &::-webkit-scrollbar-track {
            background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;
`